import { useStaticQuery, graphql } from 'gatsby'

export function useDataThirdScreenByEn() {
    const data = useStaticQuery(graphql`
        {
            sectionTitle: datoCmsRenshinPageMain(title: { eq: "Slide 3: Title small" }, locale: { eq: "en" }) {
                value
            }

            title: datoCmsRenshinPageMain(title: { eq: "Slide 3: Title" }, locale: { eq: "en" }) {
                value
            }

            text: datoCmsRenshinPageMain(title: { eq: "Slide 3: Text" }, locale: { eq: "en" }) {
                value
            }

            buttonText: datoCmsRenshinPageMain(title: { eq: "Slide 3: Button" }, locale: { eq: "en" }) {
                value
            }

            heroImage: datoCmsRenshinPageMain(title: { eq: "Slide 3: Image" }, locale: { eq: "en" }) {
                image {
                    url
                }
            }
        }
    `)

    return data
}
